import { useRef, useEffect } from 'react';
import bem from '../../../utils/bem';
import { useAnalyticsPushEvent } from '../../../analytic/analytic.context';

const FooterText = ({ heading, text, textClasses = '', analyticData }) => {
  const pushAnalyticEvent = useAnalyticsPushEvent();
  const blockRef = useRef(null);
  const baseClass = 'footer-text';

  useEffect(() => {
    const container = blockRef.current;
    const links = container.querySelectorAll('a');
    const linkClickHandler = (e) => {
      if (analyticData) {
        pushAnalyticEvent({
          ...analyticData,
          component_name: '[B46] Links',
          link_text: e.target.innerText,
          link_url: e.target.href,
        });
      }
      return undefined;
    };
    if (links.length) {
      links.forEach((link) => {
        link.addEventListener('click', linkClickHandler);
      });
    }

    return () => {
      if (links.length) {
        links.forEach((link) => {
          link.removeEventListener('click', linkClickHandler);
        });
      }
    };
  }, []);
  return (
    <div className={bem(baseClass, [], '')}>
      {heading && <h5>{heading}</h5>}
      {text && (
        <div
          ref={blockRef}
          className={textClasses}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
    </div>
  );
};

export default FooterText;
